module.exports = __webpack_public_path__ + "img/2.1ee11a4c.png";